import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-modal-cookies',
  templateUrl: './modal-cookies.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCookiesComponent implements OnInit {
  private readonly COOKIES_KEY = 'CnvCookies';
  isVisibleCookies = signal(true);

  ngOnInit(): void {
    this.getCookie();
  }

  setCookie(): void {
    localStorage.setItem(this.COOKIES_KEY, '');
    this.getCookie();
  }

  getCookie(): void {
    this.isVisibleCookies.set(localStorage.getItem(this.COOKIES_KEY) === null);
  }
}
